import { useEffect, useState } from "react";
import { DisconnectOutlined, WifiOutlined } from "@ant-design/icons";
import type { Toast } from "antd-mobile";
import styles from "./styles.module.scss";

export interface INetworkBar {
  connectionStatus: boolean;
  toast: typeof Toast;
}

export const NetworkBar: FC<INetworkBar> = ({ connectionStatus, toast }) => {
  const [connection, setConnection] = useState<INetworkBarStatus>(null);

  useEffect(() => {
    if (connectionStatus && connection === "disconnected") {
      setConnection("connected");
      toast.show({
        content: (
          <div className={styles.connectedToast} data-test-id="bar">
            <WifiOutlined /> Internet Connection Restored
          </div>
        ),
        position: "bottom",
        maskClassName: styles.mask,
      });
    }
    if (!connectionStatus && connection !== "disconnected") {
      setConnection("disconnected");
      toast.show({
        content: (
          <div className={styles.disconnectedToast} data-test-id="bar">
            <DisconnectOutlined /> No Internet Connection
          </div>
        ),
        position: "bottom",
        maskClassName: styles.mask,
      });
    }
  }, [connectionStatus]);

  return <></>;
};
